import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { ArrowUpwardRounded } from '@mui/icons-material';
import './ScrollToTop.css';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <Box className="scroll-to-top">
      {isVisible && (
        <Box className="top-btn" onClick={scrollToTop}>
          <ArrowUpwardRounded className="up-arrow-icon" />
        </Box>
      )}
    </Box>
  );
};

export default ScrollToTop;
